<template>
	<div class="c-body">
		<div class="c-body__title">
			<h2>
				<span>GridCalc</span>
				<button @click="toggleHelp" :class="{'-active': showHelp}">
					<c-icon :name="'question-circle'"></c-icon>
				</button>
			</h2>
		</div>
		<div class="c-help">
			<div class="c-help__inner">
				<div class="e-section">
					<p>
						グリッドのカラム幅と溝を計算する計算機です。
						整数値の結果だけを出力します。<br>
						プレビューはおおまかなイメージなので実寸ではありません。<br>
						<small>[IMO] %で指定する気もするのでもうこれ要らない説。</small>
					</p>
				</div>
			</div>
		</div>
		<div class="c-body__inner">
			<div class="e-section">
				<div class="e-grid -triple -center">
					<div class="col">
						<div class="e-label-list">
							<label class="e-label">
								<span class="label">合計幅:</span>
								<input type="number" class="e-input-text -smallest -center" v-model="options.total" min="1" max="2048" @blur="calculate">
							</label>
							<label class="e-label">
								<span class="label">カラム数:</span>
								<input type="number" class="e-input-text -smallest -center" v-model="options.cols" min="1" max="999" @blur="calculate">
							</label>
						</div>
					</div>
					<div class="col">
						<label class="e-label">
							<input type="checkbox" v-model="options.end" @change="calculate">
							<span class="label">両端の余白を含めて計算する</span>
						</label>
					</div>
					<div class="col">
						<button class="e-button -primary -full" @click="calculate">グリッド計算</button>
					</div>
				</div>
			</div>
			<hr class="e-hr">
			<div class="e-section">
				<transition name="slide-in">
					<div class="c-error-list" v-if="results !== null && ! results.length">
						<ul class="c-error-list__list">
							<li class="c-error-list__item">
								<c-icon :name="'error'"></c-icon>
								該当する結果がありません
							</li>
						</ul>
					</div>
				</transition>
				<transition name="slide-in">
					<div class="c-gridcalc-result" v-if="results && results.length">
						<table>
							<thead>
								<tr>
									<th>カラム幅</th>
									<th>溝幅</th>
									<th>プレビュー</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(r, i) in results" :key="i">
									<td>{{r.col}}</td>
									<td>{{r.gutter}}</td>
									<td>
										<div class="c-gridcalc-result__preview" :class="{'-end': r.end}">
											<div class="c-gridcalc-result__preview-item"
												v-for="(col, j) in r.preview"
												:style="{width: col + '%'}"
												:key="j"
											></div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>


<script>

import mCommon from "../mixins/common";

export default {
	mixins: [
		mCommon
	],

	data (){
		return {
			options: {
				total: 960,
				cols: 12,
				end: false
			},
			results: null
		}
	},

	methods: {
		calculate (){
			var o = this.options;
			var r = [];

			o.total = parseInt(o.total, 10);
			o.cols = parseInt(o.cols, 10);

			// ガッターの最大サイズ（カラム幅の0.25）
			var gutter = parseInt((o.total / o.cols) * 0.25, 10);
			var col;

			// ガッターの数
			var gutterCount = o.end ? o.cols + 1 : o.cols - 1;
			var preview;

			// ガッターサイズを減算してテストしていく
			while(gutter--){
				col = (o.total - (gutter * gutterCount)) / o.cols;
				if(! Number.isInteger(col)) continue;

				// プレビュー作る
				preview = this.getPreview(col, gutter, o.total, o.cols, o.end);

				r.push({
					gutter,
					col,
					preview,
					end: o.end
				});
			}

			this.results = r;
		},

		getPreview (col, gutter, total, cols, end){
			var c = (col / total * 100).toString(),
				g = (gutter / total * 100).toString(),
				preview = _.repeat(c + ",", cols).replace(/,$/, "");

			preview = preview.split(",").join("," + g + ",").split(",");
			if(end){
				preview.unshift(g);
				preview.push(g);
			}

			return preview;
		}
	}
}

</script>


// WEBPACK FOOTER //
// gridcalc.vue?d9463224